import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeZone'
})
export class TimeZonePipe implements PipeTransform {

  transform(date: string | Date, timezone: string =  'America/New_York'): string {
    const localDate = new Date(date).toLocaleString("en-US", { timeZone: timezone });
    return localDate;
  }

}
